// Add a soft shadow on scroll, Shapes-safe
(function(){
  const header = document.querySelector('#shopify-section-' + document.currentScript.dataset.sectionId + ' .site-header');
  if(!header) return;
  let on = false;
  const set = () => {
    const y = window.scrollY || 0;
    if(y>4 && !on){ header.classList.add('header-has-shadow'); on = true; }
    if(y<=4 && on){ header.classList.remove('header-has-shadow'); on = false; }
  };
  set(); window.addEventListener('scroll', set, { passive:true });
})();
